"use client";

import axios from "axios";

const api = axios.create({
  baseURL: process.env.NEXT_PUBLIC_BASE_PATH || "",
  withCredentials: true,
});

let refreshPromise: Promise<boolean> | null = null;

const SKIP_INTERCEPTOR_URLS = [
  "/api/auth/token/refresh",
  "/api/auth/logout",
];

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response?.status !== 401 ||
      originalRequest._retry ||
      SKIP_INTERCEPTOR_URLS.some((url) => originalRequest.url?.includes(url))
    ) {
      return Promise.reject(error);
    }

    originalRequest._retry = true;

    const refreshed = await doRefresh();

    if (refreshed) {
      return api(originalRequest);
    }

    return Promise.reject(error);
  }
);

async function doRefresh(): Promise<boolean> {
  if (refreshPromise) return refreshPromise;

  refreshPromise = api
    .post("/api/auth/token/refresh")
    .then(() => true)
    .catch(() => false)
    .finally(() => {
      refreshPromise = null;
    });

  return refreshPromise;
}

export default api;